const config = {
  dev: 'dev',
  stage: 'prod',
  prod: 'prod',
};

function loadConfig(env) {
  if (env && config[env]) {
    return require(`./${config[env]}.js`);
  } else {
    console.warn(`Unknown environment: ${env}`);
    return require('./dev.js');
  }
}

function getConfig(env) {
  return Object.assign({}, loadConfig(env), { env });
}

module.exports = getConfig(process.env.REACT_APP_BUILD_ENV);
